import { ReactNode, useState } from "react";
import Sidebar from "./Sidebar";

interface LayoutProps {
    children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    return (
        <div className="min-h-screen bg-background">
            <div className="flex">
                <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
                <main
                    className="flex-1 p-2 md:p-4 lg:p-6 overflow-y-auto transition-all duration-300 lg:h-screen pt-[70px] lg:pt-6"
                >
                    {children}
                </main>
            </div>
        </div>
    );
}